import { QueryClient } from "react-query";

export default new QueryClient({
  defaultOptions: {
    queries: { cacheTime: 1000 * 60 * 3, staleTime: 1000 * 60 * 2 },
  },
});
